import styles from "./AscCalendarDayView.module.scss";
import classNames from "classnames";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import { useMemo } from "react";
import { AscCalendarEvent } from "../AscCalendarEvents.types";
import { CalendarDate } from "../../../lib/helpers/hooks/useCalendarDays";
dayjs.extend(isToday);

interface AscCalendarDayViewProps {
  dayLabel: string;
  date: Date;
  activeMonth: boolean;
  events?: AscCalendarEvent[];
  onDayClick?: (day: CalendarDate) => void;
}
export default function AscCalendarDayView({
  dayLabel,
  date,
  activeMonth,
  events,
  onDayClick,
}: AscCalendarDayViewProps) {
  const isToday = useMemo(() => dayjs(date).isToday(), [date]);

  function getStyles(color?: string): React.CSSProperties {
    return { "--typeColor": color || "var(--brandRed)" } as React.CSSProperties;
  }

  if (!dayLabel) {
    return <div />;
  }

  function handleClick() {
    onDayClick?.({
      date,
      events,
      dayLabel,
    });
  }

  return (
    <button
      className={classNames(styles.ground, {
        [styles.isToday]: isToday,
        [styles.activeMonth]: activeMonth,
        [styles.hasEvents]: events?.length,
      })}
      style={getStyles(events?.[0]?.type?.color)}
      type="button"
      onClick={handleClick}
    >
      {dayLabel?.toLocaleString()}
    </button>
  );
}
